import React, { Component } from 'react';
import * as Config from './../config/Config';
import * as Common from './../helpers/Common';
import * as User from './../helpers/User';

const $=window.$;
const win=window;
 
class XRecap extends Component {
  constructor(props) {
   
    super(props);
        this.state={
          image_xrecap :[]
        };

  }
 
  show_image(x,y){
    
    let dd = Config.rootDomainUrl+'admin/dlr_video_files/xRecap/'+x;
    
    $('#thumbnail').css('display','none');
    $('#showimage').css('display','block');
    
    $("#image_title_name").html(y);
    $("#image_change").attr("src",dd);
  }

  hide_image(){
    $('#thumbnail').css('display','block');
    $('#showimage').css('display','none');
  }  
  getXrecap(){
      //let xrecap_id = Common.getUserData("xrecap_id", true);

      Common.reactLoader("show", "Please wait...");
      fetch(Config.domainUrl+'xrecap/xrecap', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization':'Bearer ' +Common.getTokenData()
                },
                  body: JSON.stringify({
                    learner_id: User.UserId(),
                    // xrecap_id:xrecap_id
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
                if(responseJson.status !== 0){
                  let image_xrecap=(responseJson.xrecap.image_xrecap!==undefined) ? responseJson.xrecap.image_xrecap : '';
                   
                 this.setState({
                     xrecap: responseJson.xrecap,
                     image_xrecap:image_xrecap
                 });
                }
                    Common.reactLoader("hide");
                    Common.downTabClose();

            });
    }

  componentDidMount() {
    setTimeout(()=>{
        this.getXrecap();
        //Common.showSmallLeftMenu();  
    },500)
  } 

  getLrinfo(type,lr_id,dlr_id){
    this.props.switchPanel(type,lr_id,dlr_id);
  }

    render() {
      let image_xrecap_list = null;
        if(this.state.image_xrecap!==null || this.state.image_xrecap!==undefined) {
          image_xrecap_list= this.state.image_xrecap.map((key,index)=>{
            let dh = 1; 
              return <div key={`lrwise${index}`} className="fleft">
               
                {key['xreimage'].map((val,ind)=>{ 
                                             
                  return <div className="img_xrecap">
                  <img  src={Config.rootDomainUrl+'/admin/dlr_video_files/xRecap/'+val} onClick={(e) =>this.show_image(val,key['xreimage_title'][ind])} alt="" width="400" height="200" style={{cursor:'pointer'}} /> 
                  <div className="desc_xrecap">{key['xreimage_title'][ind]}</div>
                  <span className="number">{key['image_num']}</span>
                  </div>
                  
                })
              }                                   
          </div>
                });
    }
    
    return (
     <section id="contentsection" className="contentarea" style={{width:'92.2%'}} >

       <div className="xrecap_title">
         <h1>Recaps</h1>
       </div>

       <div className="xrecap_body">
        <div id="thumbnail">
          {image_xrecap_list}                       
        </div>
        <div id="showimage" style={{display:'none', border:'0px solid #342356', width:'90%', height:'75%'}} >
            <span style={{float:"right"}}><a href="javascript:void(0);" onClick={(e) =>this.hide_image()}>Close</a></span>
            <strong id="image_title_name"></strong><br />
            <img id="image_change" src="" alt="" /> 

        </div>
      </div>

     </section>
      );   

    }
}
export default XRecap;



// WEBPACK FOOTER //
// ./src/xrecap/XRecap.js